
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class BranchOutItemsGrid extends Serenity.EntityGrid<BranchOutItemsRow, any> {
        protected getColumnsKey() { return 'Inventory.BranchOutItems'; }
        protected getDialogType() { return BranchOutItemsDialog; }
        protected getIdProperty() { return BranchOutItemsRow.idProperty; }
        protected getInsertPermission() { return BranchOutItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return BranchOutItemsRow.localTextPrefix; }
        protected getService() { return BranchOutItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
       
        }
        
    }
}